import { paths } from '../paths';
import { lazyLoadPage } from '../utils';

export const contactRoutes = [
  {
    path: paths.CONTACTS,
    element: lazyLoadPage('/contacts', { path: '(dashboard)' }),
    state: {
      pageKey: 'ContactList',
      metadata: {
        title: 'My contacts'
      }
    }
  },
  {
    path: paths.CONTACT_TAGS,
    element: lazyLoadPage('/contacts/tags', { path: '(dashboard)' }),
    state: {
      pageKey: 'ContactTags',
      metadata: {
        title: 'My contact tags'
      }
    }
  },
  {
    path: paths.CONTACT_DETAIL(),
    element: lazyLoadPage('/contacts/[contactId]', { path: '(dashboard)' }),
    state: {
      pageKey: 'ContactDetail',
      metadata: {
        title: 'Contact detail'
      }
    }
  }
];
